<script setup lang="ts">
import { onKeyDown } from '@vueuse/core'
import { useModal } from '~/composables/useModal'

const emit = defineEmits(['confirm', 'cancel'])
const modal = useModal()

const props = defineProps<{
  playerName: string
  remainingScore: number
  minDartsUsed: number[]
}>()

function confirm(dartsUsed: number) {
  emit('confirm', dartsUsed)
  modal.close()
}

function cancel() {
  emit('cancel')
  modal.close()
}

onKeyDown('Enter', (e) => {
  e.stopPropagation()
  e.preventDefault()
})

onKeyDown('Backspace', () => {
  cancel()
})

onKeyDown('1', () => {
  if (props.minDartsUsed.find(item => item === 1)) {
    confirm(1)
  }
})
onKeyDown('2', () => {
  if (props.minDartsUsed.find(item => item === 2)) {
    confirm(2)
  }
})
onKeyDown('3', () => {
  if (props.minDartsUsed.find(item => item === 3)) {
    confirm(3)
  }
})
</script>

<template>
  <UiAlertDialog v-model:open="modal.isOpen.value">
    <UiAlertDialogContent @escape-key-down="cancel">
      <UiAlertDialogTitle class="text-4xl">
        {{ $t('Game shot!') }}
      </UiAlertDialogTitle>
      <div class="text-4xl mb-6">
        {{
          $t('Please confirm how many darts were used to finish {remainingScore} by {playerName}', {
            remainingScore,
            playerName,
          })
        }}
      </div>
      <div class="grid grid-cols-3 gap-4 mb-6">
        <template
          v-for="dart in minDartsUsed"
          :key="dart"
        >
          <UiButton
            variant="default"
            size="huge"
            class="text-4xl h-20"
            @click="() => confirm(dart)"
          >
            {{ dart }}
          </UiButton>
        </template>
      </div>
      <UiAlertDialogFooter>
        <UiButton
          variant="destructive"
          size="huge"
          @click="cancel"
        >
          {{ $t('Cancel') }}
        </UiButton>
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>
